/** @sfdc-extension-file SNK */

/** Keys for parallel embedded footer hosts (one getComponent per key). */
export const GLOBAL_FOOTER_REGION_KEYS = [
    'footerRegion01',
    'footerRegion02',
    'footerRegion03',
    'footerRegion04',
    'footerRegion05',
    'socialMediaIcons',
    'paymentMethodIcons',
] as const;

export type GlobalFooterRegionKey = (typeof GLOBAL_FOOTER_REGION_KEYS)[number];

/** Stable SCAPI `getComponent` ids for each embedded footer region host. */
export const GLOBAL_FOOTER_COMPONENT_IDS: Record<GlobalFooterRegionKey, string> = {
    footerRegion01: 'global-footer-link-column-01',
    footerRegion02: 'global-footer-link-column-02',
    footerRegion03: 'global-footer-link-column-03',
    footerRegion04: 'global-footer-link-column-04',
    footerRegion05: 'global-footer-link-column-05',
    socialMediaIcons: 'global-footer-social-media',
    paymentMethodIcons: 'global-footer-payment-methods',
};

export const GLOBAL_FOOTER_LINK_REGION_KEYS = [
    'footerRegion01',
    'footerRegion02',
    'footerRegion03',
    'footerRegion04',
    'footerRegion05',
] as const satisfies readonly GlobalFooterRegionKey[];

export type GlobalFooterLinkRegionKey = (typeof GLOBAL_FOOTER_LINK_REGION_KEYS)[number];
